import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {ChartService, DoughnutChartData} from "../../../tandem-core/services/chart.service";
import {CurrencyService} from "../../../tandem-core/services/currency.service";
import {ArcElement, CategoryScale, Chart, DoughnutController, Legend, Title, Tooltip} from "chart.js";
import {CashFlow} from "../../models/cash-flow";
import {CashFlowService} from "../../services/cash-flow.service";
import {EChartsOption} from "echarts";
import {DateService} from "../../../tandem-core/services/date.service";

@Component({
  selector: 'tandem-cash-flow-graph',
  templateUrl: './cash-flow-graph.component.html',
  styleUrls: ['./cash-flow-graph.component.scss']
})
export class CashFlowGraphComponent implements AfterViewInit {

  @Input() cashFlow: CashFlow | undefined;
  @Input() omitLabelLines: boolean = false;
  @Input() showSubtitle: boolean = false;
  @Input() showLegend: boolean = false;
  @Input() isSampleData: boolean = false;

  chart: any;
  chartOption: EChartsOption | null = null;

  constructor(private chartService: ChartService, private currencyService: CurrencyService, private cfService: CashFlowService, private dateService: DateService) {
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      const sections: any[] = [];
      const categories: any[] = [];
      const sectionCategoryCounts: {[key: string]: number} = {};

      // Handle revenue sections
      this.cashFlow?.revenueSections.forEach(section => {
        const total = section.categories.reduce((acc, cat) => acc + cat.total, 0);
        if (total > 0) {
          sections.push({
            name: section.name,
            value: total,
            isRevenue: true
          });
        }

        const activeCats = section.categories.filter(cat => cat.total > 0);
        sectionCategoryCounts[section.name] = activeCats.length;

        activeCats.forEach(cat => {
          categories.push({
            name: cat.name,
            value: cat.total,
            parentSection: section.name,
            isRevenue: true
          });
        });
      });

      // Handle expense sections
      this.cashFlow?.expenseSections.forEach(section => {
        const total = section.categories.reduce((acc, cat) => acc + cat.total, 0);
        if (total > 0) {
          sections.push({
            name: section.name,
            value: total,
            isRevenue: false
          });
        }

        const activeCats = section.categories.filter(cat => cat.total > 0);
        sectionCategoryCounts[section.name] = activeCats.length;

        activeCats.forEach(cat => {
          categories.push({
            name: cat.name,
            value: cat.total,
            parentSection: section.name,
            isRevenue: false
          });
        });
      });

      const innerSeries = {
        name: 'Items',
        data: sections
      };

      const outerSeries = {
        name: 'Categories',
        data: categories,
        sectionCategoryCounts
      };

      this.chartOption = this.chartService.generatePieChart(
        innerSeries,
        outerSeries,
        this.showLegend,
        this.omitLabelLines
      );
    });
  }

  getTitle() {
    return `Net Cash Flow: ${this.currencyService.formatNumber(this.cashFlow?.netCashFlow || 0)}`;
  }

  getSubtitle() {
    return this.showSubtitle ? `From ${this.dateService.formatTimestamp(this.cashFlow!.startDate)} to ${this.dateService.formatTimestamp(this.cashFlow!.endDate)}` : undefined;
  }
}
